/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { DeleteInventoryRequestDTOToJSON, InventoryDTOFromJSON, InventoryDeletePreviewDTOFromJSON, InventoryRequestDTOToJSON, PaginatedResponseInventoryDTOFromJSON, } from '../models/index';
/**
 *
 */
export class InventoryControllerApi extends runtime.BaseAPI {
    /**
     */
    async deleteInventoriesRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling deleteInventories().');
        }
        if (requestParameters['deleteInventoryRequestDTO'] == null) {
            throw new runtime.RequiredError('deleteInventoryRequestDTO', 'Required parameter "deleteInventoryRequestDTO" was null or undefined when calling deleteInventories().');
        }
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/products`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteInventoryRequestDTOToJSON(requestParameters['deleteInventoryRequestDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteInventories(requestParameters, initOverrides) {
        await this.deleteInventoriesRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getInventoryProductDetailRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getInventoryProductDetail().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/products/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InventoryDTOFromJSON(jsonValue));
    }
    /**
     */
    async getInventoryProductDetail(requestParameters, initOverrides) {
        const response = await this.getInventoryProductDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getInventoryProductsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getInventoryProducts().');
        }
        if (requestParameters['inventoryRequestDTO'] == null) {
            throw new runtime.RequiredError('inventoryRequestDTO', 'Required parameter "inventoryRequestDTO" was null or undefined when calling getInventoryProducts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/{marketplace}/products`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InventoryRequestDTOToJSON(requestParameters['inventoryRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseInventoryDTOFromJSON(jsonValue));
    }
    /**
     */
    async getInventoryProducts(requestParameters, initOverrides) {
        const response = await this.getInventoryProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async previewInventoryDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling previewInventoryDelete().');
        }
        if (requestParameters['deleteInventoryRequestDTO'] == null) {
            throw new runtime.RequiredError('deleteInventoryRequestDTO', 'Required parameter "deleteInventoryRequestDTO" was null or undefined when calling previewInventoryDelete().');
        }
        const queryParameters = {};
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/inventory/products/delete-preview`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteInventoryRequestDTOToJSON(requestParameters['deleteInventoryRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InventoryDeletePreviewDTOFromJSON(jsonValue));
    }
    /**
     */
    async previewInventoryDelete(requestParameters, initOverrides) {
        const response = await this.previewInventoryDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const DeleteInventoriesMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const GetInventoryProductsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const PreviewInventoryDeleteMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
